export enum BlResultCode {
  Success = 0,
  InvalidArgument = 1,
  InvalidRequiredField = 2,
  NoResult = 3,
  NeedMoreInformation = 4,
  BadRequest = 5,
  DatabaseConnectionFailed = 6,
  InvalidAccountPassword = 101,
  InvalidResetKey = 102,
  NotLoggedInAccount = 103,
  InsufficientProgram = 200,
  EnvironmentProblem = 201
}